import { BrowserRouter, Routes, Route } from 'react-router-dom';

import HomePage from './pages/index';
import BunnyInfinityDemoPage from './pages/demo/bunny-infinity';
import MouseInfinityDemoPage from './pages/demo/mouse-infinity';
import LemonLegendsDemoPage from './pages/demo/lemon-legends';

const App = () => (
  <div className="App">
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route
          exact
          path="/demo/bunny-infinity"
          element={<BunnyInfinityDemoPage />}
        />
        <Route
          exact
          path="/demo/mouse-infinity"
          element={<MouseInfinityDemoPage />}
        />
        <Route
          exact
          path="/demo/lemon-legends"
          element={<LemonLegendsDemoPage />}
        />
      </Routes>
    </BrowserRouter>
  </div>
);

export default App;
